import React from 'react';
import './style.css';

const LeftSidebar = ({
	                     title,
	                     items,
	                     selectedItem,
	                     onItemSelect,
	                     showMobileMenu,
	                     setShowMobileMenu,
	                     className = "",
	                     itemClassName = "",
	                     activeItemClassName = "",
	                     iconSrc = "/img/icon/arrow.png",
	                     activeIconSrc = "/img/icon/arrowBlue.png",
	                     // FAQ specific props
	                     faqData = null,
	                     expandedQuestions = null,
	                     onSubItemSelect = null,
	                     showSubItems = false,
	                     arrowRight = false
                     }) => {
	console.log(arrowRight, items);
	
	return (
		<>
			{/* Mobile Category Selector */}
			<div className="lg:hidden">
				<button
					onClick={() => setShowMobileMenu(!showMobileMenu)}
					className="w-full bg-[#F1F9FF] rounded-lg p-4 flex items-center justify-between shadow-sm"
				>
					<span className="font-medium text-gray-700">
						{items.find(item => item.id === selectedItem)?.title || 'Chọn chủ đề'}
					</span>
					<img
						className={`w-[17px] h-[17px] transition-transform ${showMobileMenu ? 'rotate-90' : ''}`}
						src={iconSrc}
						alt="expand"
					/>
				</button>
				
				{showMobileMenu && (
					<div className="mt-2 bg-[#F1F9FF] rounded-lg shadow-lg overflow-hidden ">
						
						{items.map((item) => (
							<div key={item.id}>
								<button
									onClick={() => {
										onItemSelect(item.id);
										setShowMobileMenu(false);
									}}
									className={`w-full text-left p-4 border-b border-gray-100 last:border-b-0 flex items-center justify-between ${
										selectedItem === item.id
											? 'bg-blue-50 text-blue-600'
											: 'text-gray-700 hover:bg-gray-50'
									}`}
								>
									<div className="flex">
										{item.number && <span className={`min-w-[20px] ${
											selectedItem === item.id ? 'font-bold' : ''
										}`}>{item.number}.</span>}
										<span className={`${
											selectedItem === item.id ? 'font-bold' : ''
										}`}>{item?.title || ''}</span>
									</div>
								</button>
								
								{/* Show sub-questions only for selected category */}
								{showSubItems && selectedItem === item.id && faqData?.[item.id]?.subItems && item.id !== 'FAQ_INFO' && (
									<div className="bg-white rounded-lg">
										{faqData[item.id].subItems.map((subItem, index) => (
											<div key={subItem.id}>
												<button
													onClick={() => {
														// When clicking a subItem, expand the first contentItem
														if (subItem.contentItems && subItem.contentItems.length > 0) {
															onSubItemSelect?.(subItem.contentItems[0].id, true);
														} else {
															onSubItemSelect?.(subItem.id, true);
														}
														setShowMobileMenu(false);
													}}
													className="w-full text-left p-4 pl-8 flex items-center"
												>
													<span className={`text-sm ${
														expandedQuestions === subItem.id || subItem.contentItems?.some(contentItem => contentItem.id === expandedQuestions) ? 'text-blue-600 font-bold' : 'text-gray-800'
													}`}>
														{subItem.title}
													</span>
												</button>
											</div>
										))}
									</div>
								)}
							</div>
						))}
					</div>
				)}
			</div>
			
			{/* Desktop Sidebar - Categories */}
			<div className={`hidden lg:block lg:w-1/4 ${className}`}>
				<div className="faq-sidebar bg-[#F1F9FF] p-4">
					<h3 className="font-bold text-lg text-gray-800 mb-4 flex items-center">
						<span>{title}</span>
					</h3>
					<div className="space-y-2">
						{items.map((item) => (
							<div key={item.id}>
								<button
									onClick={() => onItemSelect(item.id)}
									className={`category-button w-full text-left py-3 rounded-lg flex text-sm ${
										selectedItem === item.id && 'active'
									}`}
								>
									<div className="flex flex-1">
										{item.number && <span className={`min-w-[20px] ${
											selectedItem === item.id ? 'font-bold' : ''
										}`}>{item.number}.</span>}
										<span className={`text-sm flex-1 ${
											selectedItem === item.id && 'active'
										}`}>{item.title}</span>
									</div>
									
									{showSubItems && faqData?.[item.id]?.subItems && faqData[item.id].subItems.length > 1 && (
										<img
											className={`faq-chevron w-[17px] h-[17px] flex-shrink-0 ${
												selectedItem === item.id && 'rotate-90'}`}
											src={selectedItem === item.id ? activeIconSrc : iconSrc}
											alt="chevron"
										/>
									)}
									{arrowRight && (
										<img
											className={`faq-chevron w-[17px] h-[17px] flex-shrink-0`}
											src={selectedItem === item.id ? activeIconSrc : iconSrc}
											alt="chevron"
										/>
									)}
								</button>
								{/* Show sub-questions only for selected category */}
								{showSubItems && selectedItem === item.id && faqData?.[item.id]?.subItems && item.id !== 'FAQ_INFO' && (
									<div className="ml-2 space-y-1 bg-white rounded-lg p-2">
										{faqData[item.id].subItems.map((subItem, index) => (
											<button
												key={subItem.id}
												onClick={() => {
													// When clicking a subItem, expand the first contentItem
													if (subItem.contentItems && subItem.contentItems.length > 0) {
														onSubItemSelect?.(subItem.contentItems[0].id, true);
													} else {
														onSubItemSelect?.(subItem.id, true);
													}
												}}
												className={`w-full text-left p-2 rounded flex items-center hover:bg-blue-50`}
											>
												<span className={`text-sm ${
													expandedQuestions === subItem.id || subItem.contentItems?.some(contentItem => contentItem.id === expandedQuestions) ? 'text-blue-600 font-bold' : ''
												}`}>
													{subItem.title}
												</span>
											</button>
										))}
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default LeftSidebar;
